/** Persisted theme preference shared by the document bootstrap and theme controls. */
export const THEME_STORAGE_KEY = 'matcha-theme';

/** Shared verbatim with CSP hashing; document attributes keep banner imports out of next.config. */
export const injectPreferencesScript = `
  function injectDarkmodePreference() {
    const setting = localStorage.getItem('${THEME_STORAGE_KEY}') || "system";
    document.documentElement.dataset['theme'] = setting;
    document.body.dataset['theme'] = setting;
  }

  function injectBannerPreference() {
    const { bannerStorageKey, showBannerDefault } = document.body.dataset;
    const dismissed = localStorage.getItem(bannerStorageKey) === 'true';
    document.body.dataset['showBanner'] = String(!dismissed && showBannerDefault === 'true');
  }

  function injectPreferences() {
    injectDarkmodePreference();
    injectBannerPreference();
  }
`;

/** Runs after the body exists, before hydration. */
export const applyPreferencesScript = 'injectPreferences()';
